import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import vi from './locales/vi.json';

// Function to get locale from URL
function getLocaleFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const lang = params.get('lang');
  if (lang === 'vi' || lang === 'en') {
    return lang;
  }
  return 'en'; // default language
}

const i18n = createI18n({
  legacy: false, // use composition API
  locale: getLocaleFromUrl(), // set locale from URL
  fallbackLocale: 'en', // set fallback locale
  messages: {
    en,
    vi,
  },
});

export default i18n;
